import { ConnectionDetails, convertConnectionToDetails, handleError, mergeConnectionDetails } from '@/utils/custom';
import { TimeFrame, TimeFrameConnection, TimeFrameConnectionInput, TimeFrameSearch } from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { SearchTimeFrameDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

export type SearchTimeFrameGraphApiResponse = GraphApiResponse<typeof SearchTimeFrameDocument>;
export type SearchTimeFrameOptions = { pageSize?: number; page?: number; merge?: true };

export const SEARCH_TIME_FRAME_PAGE_SIZE = 1000;
const title = 'Search Time Frame';

export const searchTimeFrameResponseSelector = (res: SearchTimeFrameGraphApiResponse): ConnectionDetails<TimeFrame> =>
  convertConnectionToDetails(res?.searchTimeFrame?.timeFrameConnection as TimeFrameConnection);

const [runSearchTimeFrame, runRefetchSearchTimeFrame] = graphApi(SearchTimeFrameDocument, {
  onError: (res: SearchTimeFrameGraphApiResponse): void => handleError(res, { notification: { title } }),
});

const searchTimeFrame = async (query?: TimeFrameSearch[], options: SearchTimeFrameOptions = {}): Promise<ConnectionDetails<TimeFrame>> => {
  const { pageSize = SEARCH_TIME_FRAME_PAGE_SIZE, page = 0, merge = false } = options;

  const input: TimeFrameConnectionInput = {
    first: pageSize || null,
    after: pageSize ? (pageSize * page).toString() : null,
    query,
  };
  const graphApiOptions = { merge: merge ? 'searchTimeFrame.timeFrameConnection' : undefined };

  const res = await runSearchTimeFrame({ input }, graphApiOptions);

  return searchTimeFrameResponseSelector(res);
};

export const refetchSearchTimeFrame = async (
  query?: TimeFrameSearch[],
  options: SearchTimeFrameOptions = {}
): Promise<ConnectionDetails<TimeFrame>> => {
  const { pageSize = SEARCH_TIME_FRAME_PAGE_SIZE, page = 0 } = options;

  const input: TimeFrameConnectionInput = {
    first: pageSize || null,
    after: pageSize ? (pageSize * page).toString() : null,
    query,
  };

  const res = await runRefetchSearchTimeFrame({ input });

  return searchTimeFrameResponseSelector(res);
};

export const useSearchTimeFrame = createGraphApiHook(searchTimeFrame, {
  refetch: refetchSearchTimeFrame,
  merge: mergeConnectionDetails,
});

export default searchTimeFrame;
